import { render, staticRenderFns } from "./jkWithdraw.vue?vue&type=template&id=1bfe2085&scoped=true&"
import script from "./jkWithdraw.vue?vue&type=script&lang=js&"
export * from "./jkWithdraw.vue?vue&type=script&lang=js&"
import style0 from "./jkWithdraw.vue?vue&type=style&index=0&id=1bfe2085&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfe2085",
  null
  
)

export default component.exports